export default "__VITE_ASSET__a8aac713__"